// src/lib/redux/slices/formSlice.js
import { createSlice } from "@reduxjs/toolkit";

const formSlice = createSlice({
  name: "form",
  initialState: {
    fieldErrors: {}, // To hold errors for form fields
  },
  reducers: {
    setFieldErrors: (state, action) => {
      state.fieldErrors = action.payload; // Set errors for form fields
    },
    clearFieldErrors: (state) => {
      state.fieldErrors = {}; // Clear all form errors
    },
    clearFieldError: (state, action) => {
      const field = action.payload;
      delete state.fieldErrors[field]; // Clear specific field error
    },
  },
});

export const { setFieldErrors, clearFieldErrors, clearFieldError } =
  formSlice.actions;
export default formSlice.reducer;
